module.exports = __webpack_public_path__ + "static/img/keco-recycle.6e26488.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/keco-recycle.jpg
// module id = dswY
// module chunks = 0